
class CapViewVendorForms {
  constructor(config) {
    this.config = config
  }

  // eslint-disable-next-line
  checkPermission(options = {}) {
    return Boolean(this.config)
  }

  getVendorOptions() {
    if (this.config?.vendor?.options) {
      return this.config.vendor.options
    }
    else {
      return []
    }
  }
}

function key() {
  return 'view_vendor_forms'
}

function create(config) {
  return new CapViewVendorForms(config)
}

export default {
  key,
  create,
}
